export const FETCH_USER = 'fetch_user';
export const LOGIN_USER = 'login_user';
export const KEEP_USER = 'keep_user';
export const ADD_TO_CART = 'add_to_cart';
export const REMOVE_FROM_CART  = 'remove_from_cart';